/**
 * 页面浏览事件
 * @param {String} pcauto_page_name 页面名
 */
export const detailView = (pcauto_page_name) => {
    window.sensors.track('PcautoActivityDetailView', {
        pcauto_page_name
    });
}

/**
 * 按钮点击事件
 * @param {String} pcauto_page_name 页面名
 * @param {String} pcauto_button_name 按钮名
 */
export const buttonClick = (pcauto_page_name, pcauto_button_name) => {
    window.sensors.track('PcautoActivityButtonClick', {
        pcauto_page_name,
        pcauto_button_name
    });
}

/**
 * 元素曝光事件
 * @param {String} pcauto_page_name 页面名
 * @param {String} pcauto_exposure_element 曝光元素名 
 */
export const exposure = (pcauto_page_name, pcauto_exposure_element) => {
    window.sensors.track('PcautoActivityExposure', {
        pcauto_page_name,
        pcauto_exposure_element
    });
}

export default {
    detailView,
    buttonClick,
    exposure
}
